module.exports = __webpack_public_path__ + "static/media/memory-cover-tutorial.5c4f7409.png";